// extracted by mini-css-extract-plugin
module.exports = {"whatsAppComm":"MasterSettings_whatsAppComm__JnbjH"};